import React, { useState } from "react";
import { useAuth } from "../lib/auth";
import { Navigate } from "react-router-dom";

export default function Login() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/dashboard" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setErr(""); setBusy(true);
    const r = await login(email, password);
    setBusy(false);
    if (!r.ok) setErr(r.error);
  };

  return (
    <div className="ach-login-wrap" data-testid="login-page">
      <form
        className="ach-login-card"
        onSubmit={onSubmit}
        data-testid="login-form"
        autoComplete="off"
      >
        <div className="ach-login-brand">
          <img src="/assets/logo-mark.png" alt="All Cranes" style={{maxWidth: 260, width: "80%", height: "auto", margin: "0 auto 6px"}} />
          <div className="tag">Hire System</div>
        </div>
        <div className="ach-field" style={{marginBottom: 12}}>
          <label>Your work email</label>
          <input
            data-testid="login-email"
            type="email"
            value={email}
            onChange={(e)=>setEmail(e.target.value)}
            required
            autoComplete="off"
            autoCorrect="off"
            autoCapitalize="none"
            spellCheck={false}
            placeholder="you@allcranes.com.au"
          />
        </div>
        <div className="ach-field" style={{marginBottom: 12}}>
          <label>Password</label>
          <input
            data-testid="login-password"
            type="password"
            value={password}
            onChange={(e)=>setPassword(e.target.value)}
            required
            autoComplete="new-password"
            placeholder="Enter your password"
          />
        </div>
        {err && (
          <div style={{color:"var(--ach-red)", background:"var(--ach-red-tint)", padding:"8px 12px", borderRadius:8, fontSize:12, marginBottom:12}} data-testid="login-error">
            {err}
          </div>
        )}
        <button className="ach-btn ach-btn--primary" type="submit" disabled={busy} data-testid="login-submit" style={{width:"100%", justifyContent:"center"}}>
          {busy ? "Signing in…" : "Sign in"}
        </button>
        <p style={{fontSize:11, color:"var(--ach-text-2)", marginTop:16, textAlign:"center"}}>
          Internal system — All Cranes (Hire) Pty Ltd
        </p>
      </form>
    </div>
  );
}
